const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速秒播不缓冲',
    desc: '采用多线智能加速与全球CDN分发技术，点击即播无需等待。无论高峰时段还是冷门影片，都能保证高清电影在线观看流畅不卡顿，给你丝滑的观影体验。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量电影大全',
    desc: '汇聚全球电影资源，覆盖动作、喜剧、科幻、悬疑、爱情、动画等全类型。每日持续更新最新电影，经典老片与热门新作一应俱全，满足不同口味的观影需求。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全免费观影',
    desc: '快看影视坚持免费电影在线观看，无隐藏收费、无强制注册。页面清爽无干扰，采用安全加密传输，保护你的隐私与设备安全，让你放心畅享每一部好片。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              平台优势
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              为什么选择快看影视？三大核心优势让你爱上观影
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {features.map((feature, i) => (
              <div
                key={i}
                className="group bg-background-100 rounded-2xl p-8 text-center hover:bg-background-200/50 transition-all duration-300"
              >
                <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-accent-100 mx-auto mb-5 group-hover:bg-accent-200 transition-colors">
                  <i className={`${feature.icon} text-2xl text-accent-600`}></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}